import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Combobox, ComboboxOption } from '@jutro/components';
import { MLGAFInfoService } from 'gw-capability-quoteandbind';
import _ from 'lodash';
import { platformMessages } from 'ml-components-platform-react';
import { MLModalService } from 'ml-portals-services-react';
import { RadioButtonField } from '@jutro/legacy/components';
import messages from './MLEmployersAffiliationComboBoxComponent.messages';
import { FormattedMessage, useTranslator } from '@jutro/locale';

function MLEmployersAffiliationComboBoxComponent(props) {
    const {
        companies,
        selectOrganization,
        handleSearchFieldUpdated,
        quoteID,
        sessionID,
        searchText,
        isFromFFQ
    } = props;

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const translator = useTranslator();

    const TAB_BREAKPOINT = 768;
    const [searchName, setSearchName] = useState(searchText?.length>0 ? searchText: "");
    const [gafResults, setGafResults] = useState([]);
    const [paypoint, setPaypoint] = useState(null);
    const [liveRegionMessage, setLiveRegionMessage] = useState('');


    useEffect(() => {
        if(!isFromFFQ) return;
        
        if(isFromFFQ){
            const inputEl = document.getElementById('employerAffiliationsComboBox');

            if(inputEl){
                inputEl.value =  sessionStorage.getItem('employerName');
                const expandBtn = inputEl?.parentElement?.querySelector('button'); 
                expandBtn?.click();
            }
        }

    },[isFromFFQ]);
    


    const handleSearch = (input) => {
        setGafResults([]);
        handleSearchFieldUpdated(input);
    };

    const formatStringToTitleCase = (str) => {
        return _.startCase(_.toLower(str));        
    };

    const formatMatchedNameWithInverseBold = (name) => {
        if (!name) {
            return '';
        }

        const startIndexOfB = name.indexOf('<b>');

        if (startIndexOfB === -1) {
            return <strong>{formatStringToTitleCase(name)}</strong>;
        }

        const endIndexOfB = name.indexOf('</b>');

        if (endIndexOfB === -1) {
            return <strong>{formatStringToTitleCase(name)}</strong>;
        }

        const stringBeforeBold = name.substring(0, startIndexOfB);
        const matchedSubString = name.substring(startIndexOfB + 3, endIndexOfB);
        const stringAfterBold = name.substring(endIndexOfB + 4);

        return (
            <>
                <strong>
                    {stringBeforeBold}
                </strong>
                {matchedSubString}
                <strong>
                    {stringAfterBold}
                </strong>
            </>
        );
    };

    const handleSelection = (selectedVal) => {
        console.log(selectedVal?.target?.value?.name);
        setSearchName(selectedVal?.target?.value?.name);
        let gafSearchByGpcPromise;

        gafSearchByGpcPromise = MLGAFInfoService.searchFilteredGAFByGPC(selectedVal?.target?.value?.code, sessionID, quoteID);
        showProgressDialog(platformMessages.loading,gafSearchByGpcPromise,false,0);
    
        gafSearchByGpcPromise.then((result) => {
            const gafInfos = _.filter(result.gafInfos, (gafData) => gafData.businessIndicator === true) || [];

            if (gafInfos && gafInfos.length > 0) {
                setGafResults(gafInfos);

                const announcementMessage = `${gafInfos.length} suggestions available.  Continue typing or use the arrow keys to select a different Affiliation. `;

                setLiveRegionMessage(announcementMessage);
            } else {
                setLiveRegionMessage('');
            }
        }).finally(() => {
            hideProgressDialog(true);
        }) 
    };


    const handleOrganizationSelection = (id) => {
        const selectedGaf = gafResults?.find(gaf => gaf.paypointNumber === id);
        selectOrganization(selectedGaf);
    };
    
    const isMobile = () => {
        return window.innerWidth <= TAB_BREAKPOINT;
    };

     
    return(
        <>
            <div style={
                {
                    width: isMobile() ? 'calc(90% - 32px)' : '90%', 
                    maxWidth: isMobile() ? 'calc(90% - 32px)': '350px', 
                    minWidth: isMobile() ? 0 : '250px',
                    marginBottom: '10px'
                }
            }>
                <h3>{translator(messages.header)}</h3>
                <div
                    id="affiliationLiveRegion"
                    style={{
                        position: 'absolute',
                        top: '-1000px',
                        height: '1px',
                        width: '1px',
                        overflow: 'hidden',
                        display: 'none'
                    }}
                    role="alert">
                    {liveRegionMessage}
                </div>
                <Combobox 
                    id="employerAffiliationsComboBox"
                    label= {<h5><strong>{translator(messages.selectHeader)}</strong></h5>}
                    labelPosition="top"
                    placeholder= {translator(messages.searchPlaceHolder)}
                    onSearch={(val) => handleSearch(val?.target?.value)}
                    onChange={handleSelection}
                    >
                    {
                        companies && companies.map((gaf, idx) => (
                            <ComboboxOption
                                id = {idx}
                                key = {idx}
                                value= {{
                                    id: `${idx}`,
                                    code: gaf?.gpcCode,
                                    name: gaf?.matchedName?.replace(/<\/?b./g,''),
                                    label: gaf?.matchedName?.replace(/<\/?b./g,'')
                                    //label: formatMatchedNameWithInverseBold(gaf?.matchedName)
                                }}
                            />
                        ))                
                    }
                </Combobox>   
            </div>
     
            {
                gafResults?.length > 0 && (
                    <>
                        <br />
                        <h4>
                            <strong>
                            {
                                translator(messages.selectionHeader, {searchName: searchName})
                            } 
                            </strong>
                        </h4>

                        <RadioButtonField
                            id="gafRadioList"
                            label=""
                            availableValues={
                                gafResults.map(item => {
                                    return {
                                        id: item?.paypointNumber,
                                        name: item?.paypointName,
                                        secondaryLabel: item?.payPeriod,
                                        value: item
                                    }
                                })
                            }
                            value={paypoint}
                            onValueChange={(value) => handleOrganizationSelection(value)}
                        />
                    </>
                )
            }
        </>
    );
}


MLEmployersAffiliationComboBoxComponent.propTypes = {
    companies: PropTypes.arrayOf(PropTypes.shape({})),
    selectOrganization: PropTypes.func.isRequired,
    handleSearchFieldUpdated: PropTypes.func.isRequired,
    quoteID: PropTypes.string.isRequired,
    sessionID: PropTypes.string.isRequired,
    searchText: PropTypes.string,
    isFromFFQ: PropTypes.bool
};

MLEmployersAffiliationComboBoxComponent.defaultProps = {
    companies: [],
    isFromFFQ: false
};


export default MLEmployersAffiliationComboBoxComponent;